// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"s7-z","button":"t7-z","disabled":"u7-z","creditCard":"v7-z","wrapper":"w7-z"};